import React from 'react';

const LayoutFooter = () => {
  return <></>
};

LayoutFooter.propTypes = {}

export default LayoutFooter;
